<template>
    <transition name="fade">
    <div class="alert" v-if="newNotifications.length > 0" @click="navigate">
        <p v-if="newNotifications.length === 1">{{newNotifications.length}} Nieuwe alarmering</p>
        <p v-if="newNotifications.length > 1">{{newNotifications.length}} Nieuwe alarmeringen</p>
    </div>
    </transition>
</template>

<script>
    import { RouteName } from '../utils/enums';

    export default {
        name: 'alert-component',
        data() {
            return {
                notificationMessage: '',
                newNotifications: []
            }
        },
        mounted() {
            this.$store.watch(() => this.$store.getters.getnewNotifications, notifications => {
                this.newNotifications = notifications;
            });
        },
        methods: {
            navigate() {
                // clear newNotifications when the user clicks on the new alert popup
                this.$store.dispatch('CLEAR_NEW_NOTIFICATIONS');
                // redirect to notifications overview page
                this.$router.push({ name: RouteName.NOTIFICATIONS });
            }
        }
    };
</script>

<style scoped lang="scss">
    .alert {
        font-weight: bold;
        padding: 10px;
        height: 7%;
        width: 25%;
        min-width: 320px;
        background-color: $error-dark;
        color: $white;
        border-radius: 4px;
        box-shadow: 0 -2px 8px 0px rgba(0, 0, 0, 0.8);
        cursor: pointer;
    }

    .alert p {
        cursor: pointer;
    }

    .alert p::before {
        padding-left: 10px;
        padding-right: 30px;
        content: url('../assets/icons/alarm-white.svg');
    }

    .alert:hover {
        background-color: $error;
    }

</style>
